import { get } from 'services/http';

const getSharedCustomerSelectionInfo = customerSelectionId =>
  get(`/customers/selections/shared/${customerSelectionId}`, { addKgId: true });

export default {
  getSharedCustomerSelectionInfo
};
